import { render, staticRenderFns } from "./client-actions-input.vue?vue&type=template&id=235c9a65&"
import script from "./client-actions-input.vue?vue&type=script&lang=js&"
export * from "./client-actions-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports